<router-outlet></router-outlet>
<!-- <ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando opa....</p>
</ngx-spinner> -->

<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" size="medium" color="#fff">
  <p style="color: white">
    {{ (mensagemSpinner$ | async) || 'Carregando...' }}
  </p>
</ngx-spinner>
